module.exports = __webpack_public_path__ + "static/media/C.cca94ba7.png";